<template>
  <div class="DownloadData">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <br/>
        <div style="display:block">
          <MDBDropdown v-model="dropdown1">
            <MDBDropdownToggle @click="dropdown1 = !dropdown1">
              Download Image
            </MDBDropdownToggle>
            <MDBDropdownMenu aria-labelledby="dropdownMenuButton">
              <MDBDropdownItem href="#" @click.prevent="onPrintMatrixOnly">
                Crosswalk Visualization Only
              </MDBDropdownItem>
              <MDBDropdownItem href="#" @click.prevent="onPrintAll">
                All Content
              </MDBDropdownItem>
            </MDBDropdownMenu>
          </MDBDropdown>
          <br/>
          <MDBBtn color="primary" class="mt-2" @click="onDownloadCsv">
            Download Data (CSV)
          </MDBBtn>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./_DownloadData.js" lang="js"></script>
<style src="./_DownloadData.less" lang="less" scoped></style>